import {Init} from 'core/Init';
import {APP_EVT, APP_LOCATION} from 'core/config/constants';
import {Setup} from "core/main/Setup";

class CatalogSets {

    constructor() {

        Init.emitter.on(APP_EVT.SHOW_CATALOG_SETS, this.showCatalogSets);
        Init.emitter.on(APP_EVT.RETRIEVE_CATALOG_SET, this.retrieveCatalogSet);

        $('#catalog-list').on('click','.img-block', function () {

            let design_id = $(this).attr('data-id');
            Init.emitter.emit(APP_EVT.RETRIEVE_CATALOG_SET, design_id);

        });

    }


    /**
     * show the panel that allows users to choose a prebuilt photographed set.
     * If the panel is already open, then close the panel and return.
     *
     */
    showCatalogSets = (): void => {

        document.removeEventListener('wheel', Setup.onWheel);

        $('#modal-catalog-list').modal('show');

        let data: any = {};
        data.series_id = Init.series_id;

        let _that = this;

        $.ajax({
            type: 'POST',
            url: '/data/retrieveCatalogSets',
            dataType: 'json',
            data: data
        })
            .done(function (data) {
                Init.emitter.emit(APP_EVT.FLASH_SUCCESS, data);
            })
            .fail(function (data) {
                Init.emitter.emit(APP_EVT.FLASH_ERROR, data);
            })
            .always(function (data) {
                _that.retrieveSuccess(data);
            });

    };


    /**
     *
     * @param data
     */
    retrieveSuccess = ( data ) : void => {

        let str = '<div class="row">';

        let count: number = data.length;
        let cssClass : string = 'modal-lg';
        let cols : string = 'col-4';

        if (count > 16) {

            cssClass = 'modal-extra-wide';
            cols = 'col-2';

        } else if (count > 9) {

            cssClass = 'modal-wide';
            cols = 'col-3';

        }

        $('#modal-catalog-list .modal-dialog').addClass(cssClass);

        for (let i of data) {

            str += `<div class="${cols}">
<div class="img-block" data-id="${i.id}">
<div class="img-frame"><img src="/images/product/198/${i.design_id}.jpg" /></div>
<span>${i.design_name.replace(/\-/g, ' ')}</span>
</div>
</div>`;

        }

        str += '</div>';

        $('#modal-catalog-list #line-name').text(Init.line_name);
        $('#modal-catalog-list #catalog-count').text(count);
        $('#modal-catalog-list #catalog-list').html(str);

    };


    /**
     *
     * @param design_id
     */
    retrieveCatalogSet = (design_id): void => {

        let data: any = {};

        data.design_id = design_id;

        $.ajax({
            type: 'POST',
            url: '/data/retrieveCatalogSet',
            dataType: 'json',
            data: data
        })
            .done(function (data) {
                Init.emitter.emit(APP_EVT.FLASH_SUCCESS, data);
            })
            .fail(function (data) {
                Init.emitter.emit(APP_EVT.FLASH_ERROR, data);
            })
            .always(function (data) {
                Init.emitter.emit(APP_EVT.RETRIEVE_SUCCESS, data);
            });

        if (Init.app_location == APP_LOCATION.WWW) {
            Init.emitter.emit(APP_EVT.SET_GTAG, 'open_catalog_set');
        }

        $('#modal-catalog-list').modal('hide');
        $('#btn-catalog-sets').removeClass('btn-active');
        document.addEventListener('wheel', Setup.onWheel);

    }


}

export {CatalogSets};

